<template>
  <!-- 下载 -->
  <div class="">
    <v-dialog
      class="del"
      name="dialog2"
      v-model="isShow"
      title="查看详情记录 "
      close-on-click-modal
      :modal="true"
      :width="1008"
      :height="580"
      @after-close="handleAfterClose"
      @open="open"
      append-to-body
      :showConfirm="false"
      :showCancel="false"
    >
      <div>
        <div class="main-center paddingTop-no">
          <v-input
            class=""
            v-model="searchValue"
            placeholder="请输入搜索内容"
            suffix-icon="v-icon-search"
            @change="(v) => (searchValue = v)"
          ></v-input>
          <v-button class="ml10" type="primary" name="" @click="getData">查询</v-button>
          <v-button class="" type="info" name="" @click="clear">重置</v-button>
        </div>
        <vxe-table row-id="id" :data="table" align="left" :row-style="setRowClass" ref="box">
          <vxe-table-column type="seq" show-overflow width="50" title="序号"></vxe-table-column>
          <vxe-table-column field="dev_key" show-overflow min-width="120" title="设备SN"></vxe-table-column>
          <vxe-table-column field="dev_mac" show-overflow min-width="120" title="设备MAC"></vxe-table-column>
          <vxe-column title="升级成功" min-width="100">
            <template v-slot="slotProps">
              {{ slotProps.row.upgraded === 1 ? "Y" : "--" }}
            </template>
          </vxe-column>
          <vxe-column title="升级失败" min-width="100">
            <template v-slot="slotProps">
              {{ slotProps.row.upgraded === 2 ? "Y" : "--" }}
            </template>
          </vxe-column>
          <vxe-table-column field="updatedAtShow" show-overflow min-width="120" title="更新时间"></vxe-table-column>
        </vxe-table>
        <v-pagination
          v-if="total"
          @change-page="changePage"
          @change-size="changeSize"
          :total="total"
          name="page-basic"
          is-show-total
          is-change-size
          is-input-page
          :current-page="currentPage"
        ></v-pagination>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import { formatDate } from "@/plugins/components/libs";

export default {
  components: {},
  props: {
    showInputDialog: {
      type: Boolean,
      default: false,
    },
    row: {},
  },
  data() {
    return {
      isShow: false,
      searchValue: "",
      currentPage: 1,
      pageSize: 10,
      total: 0,
      table: [],
    };
  },
  created() {},
  watch: {
    showInputDialog(newVal) {
      this.isShow = newVal;
    },
  },
  methods: {
    open() {
      this.getData();
    },
    async getData() {
      const subData = {
        app_id: sessionStorage.getItem("appid") || "",
        strategy_id: this.row.strategy_id,
        page_num: this.currentPage,
        page_size: this.pageSize,
        search: this.searchValue,
      };
      const res = await this.$getData("/td/td-iot-api/iot/upgrade/force/log/page", subData, false);
      if (res.code === 0) {
        this.table = [...res.data.list].map((item) => {
          return {
            ...item,
            updatedAtShow: item.UpdatedAt ? formatDate(new Date(item.UpdatedAt)) : "--",
          };
        });
        this.total = res.data.page_result.total;
      } else {
        if (res.code == "100410") {
          setTimeout(() => {
            this.getData();
          }, 1000);
        } else {
          this.$message.error(res.msg);
        }
      }
    },
    clear() {
      this.searchValue = "";
      this.getData();
    },
    changePage(page) {
      this.currentPage = Number(page);
      this.getData();
    },
    changeSize(size) {
      this.pageSize = Number(size);
      this.getData();
    },
    handleAfterClose() {
      this.$emit("update:showInputDialog", false);
    },
  },
  beforeDestroy() {},
};
</script>

<style lang="scss"></style>
